




























































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

import SelectUsers from "@/components/selectusers.vue";

@Component({
  components: {
    Add,
    Edit,
    SelectUsers
  }
})
export default class extends Mixins(MyList) {
  @Prop() customerId!: number;

  @Prop() stadiumId!: number;

  userId: number = 0;
  mobile: string = "";
  dispatchType: string = "stadium/accounts";

  dispatchTypeDelete = "stadium/deleteAccount";

  deleteConfirmContent = "确定要删除该taisam机器人账号吗？";

  columns: any[] = [
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", scopedSlots: { customRender: "username" } },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "过期时间", dataIndex: "valid_time_end" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showEditModal1(id: number, mobile: string) {
    this.userId = id;
    this.mobile = mobile;
    this.editModalVisible = true;
  }

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
        customer_id: this.customerId,
        is_hidden: 1,
        member_type: 7
      },
      false
    );
  }
}
